import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useFetch } from "app/hooks";
import client from "@culturehq/client";
import { UserActivity } from "chq";

type UserActivitiesState = Array<UserActivity>;

const UserActivitiesContext = createContext<UserActivitiesState>([]);

export const useUserActivities = () => useContext(UserActivitiesContext);

export const UserActivitiesProvider: React.FC = ({ children }) => {
  const [userActivities, setUserActivities] = useState<UserActivitiesState>([]);
  const { json } = useFetch((client as any).listUserActivities);

  useEffect(() => {
    if (!json.userActivities?.length) return;

    setUserActivities(json.userActivities);
  }, [json.userActivities]);

  const value = useMemo(() => userActivities, [userActivities]);

  return (
    <UserActivitiesContext.Provider value={value}>
      {children}
    </UserActivitiesContext.Provider>
  );
};
